import { Box, Typography, makeStyles, Theme } from '@material-ui/core';
import { ReactNode } from 'react';
import { Button } from '@roc/ui';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    overflow: 'hidden',
  },
  containerFrameless: {
    border: 'none',
    borderRadius: 0,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
    borderBottom: '1px solid #E0E0E0',
  },
  titleRowFrameless: {
    padding: theme.spacing(0, 0, 0.5, 0),
    borderBottom: 'none',
  },
  title: {
    fontWeight: 700,
    fontSize: '1rem',
  },
  subHeader: {
    backgroundColor: '#FAFAFA',
    padding: theme.spacing(1, 2),
    borderBottom: '1px solid #E0E0E0',
  },
  subHeaderText: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#555555',
  },
  dataRow: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    borderBottom: '1px solid #E0E0E0',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  label: {
    flex: '0 0 40%',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  value: {
    flex: 1,
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
  },
}));

export interface DocReviewSectionProps {
  children?: ReactNode;
  title?: string;
  onEditClick?: () => void;
  editModal?: ReactNode;
  hideEdit?: boolean;
  frameless?: boolean;
  // rendered below the section's frame
  postSection?: ReactNode;
}

export const DocReviewSection = ({
  children,
  title = 'Extracted Data',
  onEditClick,
  editModal,
  hideEdit = false,
  frameless = false,
  postSection,
}: DocReviewSectionProps) => {
  const classes = useStyles();

  return (
    <>
      <Box className={`${classes.container} ${frameless ? classes.containerFrameless : ''}`}>
        <Box className={`${classes.titleRow} ${frameless ? classes.titleRowFrameless : ''}`}>
          <Typography className={classes.title}>{title}</Typography>
          {onEditClick && !hideEdit && (
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={onEditClick}
              testId="edit"
            >
              Edit
            </Button>
          )}
        </Box>
        <Box>{children}</Box>
      </Box>
      {postSection}
      {editModal}
    </>
  );
};
